import { useEffect, useState, useCallback } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import { plusIcon, refreshIcon, refreshinrefils } from "../../landingscreen/modals/svgs";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { PharmacyModal } from "./modals/pharmacymodal";
import { PrescriptionModal } from "./modals/PrescriptionModal";
import { useSelector } from "react-redux";
import { OrderIcons } from "../OrderCards";
import moment from "moment";
import { getPracticeId } from "../../config/practice";
const Refillstab = ({ data, appointmentId, startDate, setShowOrders }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [Backdroploading,setBackdropLoading]=useState(false)
  useParams(); // Keep for potential future use
  const [respdata, setrespdata] = useState([]);
  console.log("respdata",respdata);
  
  const [visibleInputIndex, setVisibleInputIndex] = useState(null);
  const [filtercounts,setFilterCounts]=useState({"total_medications": 0,
        "active_medications": 0,
        "inactive_medications": 0})
  const [isPharmacySelected, setIspharmacySelected] = useState(false);
  const [pharmacyText, setPharmacyText] = useState("");
  const [pharmacySuggestions, setPharmacySuggestions] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("all");
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const practiseid = getPracticeId();
  const params = useParams();
  const dt = params.dt || startDate ;
 const userConfig = useSelector((state) => state.userconfig);
 const[selectedpharma,setSelectedPharma]=useState('')
 const [isaddpharma,setIsAddPharma]=useState(false)
 const[pharmadetails,setPharmaDetails]=useState({})
 const tabs=[
              { key: "requested", label: "Requested",prop:"req", count: filtercounts.requested_medications },
            { key: "all", label: "All",prop:"", count: filtercounts.total_medications },
 { key: "active", label: "Active",prop:"A", count: filtercounts.active_medications },
 { key: "inactive", label: "In Active", prop:"I",count: filtercounts.inactive_medications },
//  { key: "pending", label: "Pending", prop:"",count: pendingCount }
            ]
 const normalizeResponse = (data) => {
  if (!data) return [];

  const statusMap = {};
  (data.medicationstatus || []).forEach((s) => {
    statusMap[s.medicationentryid] = s;
  });

  return (data.medicationdata || []).map((med) => ({
    ...med,
    ...statusMap[med.medicationentryid], // merge status info by ID
  }));
};

  const fetchData = async({status=false,filter=undefined}) => {
    try {
      if(!status){
          setIsLoading(true)
              await api.post(`v1/${practiseid}/medications/patient/${data.patientid}/sync-medication`)
      }else{
        setBackdropLoading(true)
      }
   const countsresponse= await api.get(`/v1/${practiseid}/medications/patient/${data.patientid}/count`)
   if(countsresponse.status==200){
    setFilterCounts(countsresponse.data)
   }else{
    setFilterCounts({"total_medications": 0,
        "active_medications": 0,
        "inactive_medications": 0})
   }
  const params = {};

if (filter !== undefined && filter !== null && filter !== "") {
  params.status = filter;
}

const response = await api.get(
  `/v1/${practiseid}/medications/patient/${data.patientid}/refills`,
  { params }
)
      if (response.status === 200) {
    const merged = normalizeResponse(response.data);
      setrespdata(merged);
      console.log(merged,'d')
      } else {
        setrespdata([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBackdropLoading(false)
      setIsLoading(false);
    }
  }

const fetchpharmacydata=async()=>{
try {
  const response=await api.get(`/v1/${practiseid}/rx/patient/${data.patientid}/department/${userConfig.config.departmentid}/pharmacy`)
  if(response.status==200){
setPharmaDetails(response.data||{})
  }else{
setPharmaDetails({})
  }
} catch (error) {
  console.log(error)
}
}
useEffect(()=>{
  if(data.patientid&&practiseid){
  fetchData({status:false})
  fetchpharmacydata()
  }
console.log('dtaaa',data)
},[data.patientid])

  const fetchPharmacySuggestions = async () => {
    if (pharmacyText.trim().length > 1) {
      // Trigger API only after 3 characters
      try {
        const response = await api.post(
          `/v1/${practiseid}/rx/patient/${data.patientid}/department/${data.departmentid}/pharmalook`,
          {
            facility_name: pharmacyText,
          }
        );
        if (response.status === 200) {
          setPharmacySuggestions(response.data.slice(0, 5) || []);
        }else{
           setPharmacySuggestions([])
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    }
  }

  const toggleInputVisibility = (index) => {
    setVisibleInputIndex(visibleInputIndex === index ? null : index); // Toggles visibility for the clicked card
  };
  const updatePharmacy = async (obj) => {

    setIsLoading(true)
    try {
      await api.post(`/v1/${practiseid}/patients/${data?.patientid}/pharmacies/default`, {
  "departmentid":userConfig.config.departmentid,
  "clinicalproviderid":selectedpharma?.facilityid
      });
    } catch (error) {
      console.log(error);
    } finally {
    fetchpharmacydata()
      setPharmacyText("");
      setSelectedPharma('')
    setIsLoading(false)
    }
  };
  const updateDuration = async (obj) => {
    try {
      await api.put(`/v1/${practiseid}/patient/refills/duration`, obj);
    } catch (error) {
      console.log(error);
    } finally {

    }
  };
  const markstatus=async(x)=>{
    try {
      setBackdropLoading(true)
 const formData = new FormData();

Object.entries(x).forEach(([key, value]) => {
  formData.append(key, value);
});
formData.append("orderdate",dt)
formData.append("pat_name",userConfig.username)
formData.append("userprovider",x.refil == "Y" ? 1 : 0);

const response = await api.post(
  `/v1/${practiseid}/medications/patient/${data.patientid}/update`,
  formData,
  {
    headers: {
      "Content-Type": "multipart/form-data", // 👈 force it if axios defaults block
    },
  }
);

    } catch (error) {
      console.log(error)
    }finally{
      setBackdropLoading(false)
      const selectedfilter= tabs.find(t=>t.key==activeTabKey)
      fetchData({status:true,filter:selectedfilter?.prop})

    }
  }

  // Calculate summary statistics
  const pendingCount =
    respdata?.filter((item) => item.refil === "Y" && item.active === "A")
      .length || 0;
  const approvedCount = 0; // This would need to be tracked separately
  const cancelledCount = 0; // This would need to be tracked separately
  const totalCount = respdata?.length || 0;
  const activeCount =
    respdata?.filter((item) => item.active === "A").length || 0;
  const inactiveCount =
    respdata?.filter((item) => item.active !== "A").length || 0;

  const RowCheck = ({ on }) => (
    <span className={`bmor-rf-check${on ? " on" : ""}`} aria-hidden="true">
      {on && (
        <svg width="10" height="9" viewBox="0 0 8 7" fill="none">
          <path d="M7.10223 1.21094L2.50848 5.80469L0.42041 3.71662" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </span>
  );
  const stats = [
    { label: "Pending refills", value: filtercounts?.pending_refills || 0, tone: "blue" },
    { label: "Approved today", value: filtercounts?.approved_today || 0, tone: "green" },
    { label: "Cancelled today", value: filtercounts?.cancelled_today || 0, tone: "red" },
    {
      label: "Total requests",
      value:
        (filtercounts?.pending_refills || 0) +
        (filtercounts?.approved_today || 0) +
        (filtercounts?.cancelled_today || 0),
      tone: "grey",
    },
  ];

  return (
    <>
      <div className="bmor bmor-rf">
        {/* Summary */}
        <div className="bmor-rf-stats">
          {stats.map((s) => (
            <div key={s.label} className="bmor-rf-stat">
              <div className={`bmor-rf-stat-v ${s.tone}`}>{s.value}</div>
              <div className="bmor-rf-stat-l">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Default pharmacy */}
        <div className="bmor-rf-pharmacy">
          <div style={{ minWidth: 0 }}>
            <div className="bmor-section-title">Default pharmacy</div>
            <div className="bmor-rf-ph-name">{pharmadetails?.clinicalprovidername || "-"}</div>
            <div className="bmor-rf-ph-addr">{pharmadetails?.address1 || "-"}</div>
          </div>
          <button type="button" className="bmor-btn" onClick={() => { setIsAddPharma(true); }}>
            Change pharmacy
          </button>
        </div>

        {/* Filters + add */}
        <div className="bmor-rf-toolbar">
          <div className="bmor-chips">
            {tabs.map((t) => {
              const selected = activeTabKey === t.key;
              return (
                <button
                  key={t.key}
                  type="button"
                  className={`bmor-rf-filter${selected ? " on" : ""}`}
                  aria-pressed={selected}
                  onClick={() => {
                    setActiveTabKey(t.key);
                    if (t.prop) {
                      fetchData({ status: false, filter: t.prop });
                    } else {
                      fetchData({ status: false });
                    }
                  }}
                >
                  {t.label}
                  <span className="bmor-tab-n">{t.count}</span>
                </button>
              );
            })}
            <button
              type="button"
              className="bmor-rf-filter ghost"
              onClick={() => {
                setActiveTabKey("all");
                fetchData({ status: false, filter: "" });
              }}
            >
              {refreshinrefils}
              Refresh
            </button>
          </div>
          <button type="button" className="bmor-btn primary" onClick={() => setShowPrescriptionModal(true)}>
            {OrderIcons.plus}
            Add medication
          </button>
        </div>

        <div className="bmor-rf-table">
          {isLoading ? (
            <div className="bmor-card-empty">Loading…</div>
          ) : respdata?.length ? (
            <>
              <div className="bmor-rf-scroll">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: 52 }}>
                        <RowCheck on={respdata.every((res) => res.refillApprove == "Y")} />
                      </th>
                      <th>Medication</th>
                      <th>Quantity</th>
                      <th>Duration</th>
                      <th>Status</th>
                      <th style={{ textAlign: "right" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {respdata.map((res, index) => {
                      const qty = res.unstructuredsig?.match(/\b\d+\b/);
                      const days = res?.unstructuredsig?.match(/(\d+\s*days?)/i);
                      const approved = res.refillApprove == "Y";
                      return (
                        <tr key={index}>
                          <td>
                            <RowCheck on={approved} />
                          </td>
                          <td>
                            <div className="bmor-item-name" style={{ fontSize: 15 }}>{res?.medication}</div>
                            {res?.created_at == null ? null : (
                              <div className="bmor-item-sub">
                                Requested {moment(res?.created_at).format("MM/DD/YYYY")}
                              </div>
                            )}
                          </td>
                          <td>{qty ? <span className="bmor-rf-qty">{qty[0]}</span> : null}</td>
                          <td>{days ? days[0] : ""}</td>
                          <td>
                            {approved ? (
                              <span className="bmor-pill ok" style={{ marginTop: 0 }}>Approved</span>
                            ) : (
                              <span className="bmor-pill" style={{ marginTop: 0, background: "#fef6dc", color: "#8a5a00" }}>Pending</span>
                            )}
                          </td>
                          <td>
                            <div className="bmor-rf-actions">
                              <button
                                type="button"
                                className="bmor-rf-approve"
                                disabled={approved}
                                onClick={() => {
                                  let obj = {
                                    patientid: data?.patientid,
                                    practiseid: practiseid,
                                    medicationentryid: res.medicationentryid,
                                    userprovider: 0,
                                    status: "A",
                                    refill: "Y",
                                  };
                                  markstatus(obj);
                                }}
                              >
                                <CheckIcon fontSize="small" />
                                Approve
                              </button>
                              <button
                                type="button"
                                className="bmor-rf-reject"
                                onClick={() => {
                                  let obj = {
                                    patientid: data?.patientid,
                                    practiseid: practiseid,
                                    medicationentryid: res.medicationentryid,
                                    status: "I",
                                    refill: res.status === "N",
                                  };
                                  markstatus(obj);
                                }}
                              >
                                <CloseIcon fontSize="small" />
                                Reject
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {isaddpharma && (
                <PharmacyModal
                  pharmacyText={pharmacyText}
                  setPharmacyText={setPharmacyText}
                  pharmacySuggestions={pharmacySuggestions}
                  setPharmacySuggestions={setPharmacySuggestions}
                  isPharmacySelected={isPharmacySelected}
                  setIspharmacySelected={setIspharmacySelected}
                  updatePharmacy={updatePharmacy}
                  visibleInputIndex={visibleInputIndex}
                  respdata={respdata}
                  onClose={() => setIsAddPharma(false)}
                  setSelectedPharma={setSelectedPharma}
                  fetchPharmacySuggestions={fetchPharmacySuggestions}
                />
              )}

              {showPrescriptionModal && (
                <PrescriptionModal
                  selectedpharma={pharmadetails}
                  userdata={data}
                  isOpen={showPrescriptionModal}
                  onClose={() => setShowPrescriptionModal(false)}
                />
              )}

              <div className="bmor-card-foot">
                <span>{pendingCount} pending refill(s) require attention</span>
                {/* These two had no action before either; kept as they were. */}
                <span style={{ display: "flex", gap: 10 }}>
                  <button type="button" className="bmor-rf-approve">Approve all pending</button>
                  <button type="button" className="bmor-rf-reject outline">Cancel all pending</button>
                </span>
              </div>
            </>
          ) : (
            <div className="bmor-card-empty">No data available</div>
          )}
        </div>
      </div>
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading || Backdroploading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
    </>
  );
};
export default Refillstab;
